const validator = ((input: string, validators: string[]) => {
  let err = "";
  const visaRegEx = /^4[0-9]{12}(?:[0-9]{3})?$/;
  const mastercardRegEx = /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/;
  const amexpRegEx = /^3[47][0-9]{13}$/;
  const discovRegEx = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  validators.some((validate: string) => {
    switch (validate) {
      case "required":
        if (input.length > 0) err = "";
        else err = "Blank: This field is required";
        break;
      case "name":
        if (input.length <= 30) err = "";
        else err = "Invalid: Please enter valid name";
        break;
      case "payment":
        if (parseFloat(input.replaceAll(",", "")) >= 1.00 && parseFloat(input.replaceAll(",", "")) <= 2000.00) err = "";
        else err = "Invalid: Please enter valid amount";
        break;
      case "credit":
        if (visaRegEx.test(input) || mastercardRegEx.test(input) || amexpRegEx.test(input)
            || discovRegEx.test(input)) {
          err = "";
        } else err = "Invalid: Please enter valid card";
        break;
      case "cclength":
        if ((input.length === 17 && input[0] === "3") || input.length === 19) err = "";
        else err = "Invalid: Please enter valid card";
        break;
      case "emailFormat":
        if (emailRegex.test(input)) err = "";
        else err = "Please enter a properly formatted email address.";
        break;
      default:
        err = "";
    }
    return err;
  });
  return err;
});
export default validator;
